import { render, staticRenderFns } from "./SessionExpiredError.vue?vue&type=template&id=84c68178&scoped=true"
import script from "./SessionExpiredError.vue?vue&type=script&lang=js"
export * from "./SessionExpiredError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c68178",
  null
  
)

export default component.exports